import React from 'react';
export function Footer() {
  return <footer className="w-full py-6 md:py-8 lg:py-12 px-6 md:px-8 lg:px-20 bg-brand-navy border-t border-white/10 text-center" data-id="element-86">
      <div className="text-[16px] text-white font-semibold mb-3" data-id="element-87">
        TUBO™ Water Wellness
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-[13px] text-[#A0A0A0] mb-5" data-id="element-88">
        <span data-id="element-89">✓ Australian-Owned</span>
        <span data-id="element-90">✓ 60-Day Guarantee</span>
        <span data-id="element-91">✓ Free Support</span>
        <span data-id="element-92">✓ Fast Shipping</span>
      </div>

      <div className="text-[12px] text-brand-gray mb-4 flex flex-wrap justify-center gap-2" data-id="element-93">
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-94">
          Privacy Policy
        </a>
        <span data-id="element-95">|</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-96">
          Terms & Conditions
        </a>
        <span data-id="element-97">|</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-98">
          Shipping Info
        </a>
        <span data-id="element-99">|</span>
        <a href="#" className="hover:text-brand-orange transition-colors" data-id="element-100">
          Contact Us
        </a>
      </div>

      <div className="text-[12px] text-brand-gray" data-id="element-101">
        © 2026 TUBO™ Water Wellness. All rights reserved. ABN: [INSERT]. ACCC
        Compliant.
      </div>
    </footer>;
}